    var submitResetPassword = function(event)
    {
        event.preventDefault();
        var data            = new FormData(document.getElementById("loginForm"));
        fetch($baseUrl + '/ajax/resetPassword',
            {
                method: "POST",
                credentials: 'include',
                body: data
            }
        ).then(function(res) {
                return res.json()
            }).then(function(res) {
                var myModal = new Modal({ content: res.message });
                myModal.on('show', function(myModal, event) { event; myModal._html.header.childNodes[0].remove(); myModal._html.footer.childNodes[0].remove() });
                myModal.show();
            }).catch();

    }
    var handleResetPassword = function(event)
    {
        event.preventDefault();

        var submitLoginBtn  = document.getElementById('submitLogin');
        var submitResetBtn  = document.getElementById('submitResetPaswword');
        var inputPassword   = document.getElementById("password_container");
        var loginLabel  = document.getElementById("loginLabel");
        var status = event.target.parentNode.dataset.active;

        if(status == "false") {
            inputPassword.style.display  = 'none';
            submitLoginBtn.style.display = "none";
            submitResetBtn.style.display = "inline-block";
            loginLabel.innerHTML = 'Revenir à la connexion';
            event.target.parentNode.dataset.active = 'true';
        }
        else {
            inputPassword.style.display  = 'block';
            submitLoginBtn.style.display = "inline-block";
            submitResetBtn.style.display = "none";
            loginLabel.innerHTML = 'Mot de passe oublié';
            event.target.parentNode.dataset.active = 'false';

        }
        document.querySelector("#mail_container input").value = '';
        document.querySelector("#password_container input").value = '';
    }

    var newPassword = function(event)
    {
        event.preventDefault();
        var password = document.getElementById("password_container");
        var errorContainer  = document.getElementById("error_container");
        //var form            = document.getElementById("newPassword");
        //var successContainer= document.getElementById("success_container");


        if ( password.value.length < 8 ) {
            errorContainer.innerHTML = 'Votre mot de passe est trop court.';
        }
        else {
            var serial = {
                "serial" : event.target.dataset.serial,
                "type"      : event.target.dataset.type,
                "password" : password.value
            };
            var data = new FormData();
            data.append( "data", JSON.stringify( serial ) );

            fetch($baseUrl + '/ajax/newPassword',
                {
                    method: "POST",
                    credentials: 'include',
                    body: data
                }
            ).then(function(res) {
                    return res.json()
                }).then(function(res) {
                    if(res.success) {
                        window.location = $baseUrl + res.redirect;
                    }
                    var myModal = new Modal({ content: res.message });
                    myModal.on('show', function(myModal, event) { event; myModal._html.header.childNodes[0].remove(); myModal._html.footer.childNodes[0].remove() });
                    myModal.show();
                }).catch();
        }
    }
    var handleLogin = function(event)
    {
        var formContainer   = document.getElementById("loginForm");
        //var errorContainer  = document.getElementById("error_login");

        var data            = new FormData(formContainer);

        event.preventDefault();
        fetch($baseUrl + '/ajax/login',
            {
                method: "POST",
                credentials: 'include',
                body: data
            }
        ).then(function(res){
                return res.json()
            }).then(function(res)
            {
                if(res.success === true)
                {
                    setTimeout(function()
                    {
                        window.location = $baseUrl + res.redirect;
                    }, 1000);
                }
                var myModal = new Modal({ content: res.message });
                myModal.on('show', function(myModal, event) { event; myModal._html.header.childNodes[0].remove(); myModal._html.footer.childNodes[0].remove() });
                myModal.show();
            }).catch();
    };

    if(document.getElementById('newPassword') !== null)
    {
        document.getElementById('submitReset').addEventListener("click", newPassword, false);
    }
    if(document.getElementById('submitLogin') !== null)
    {
        document.getElementById('submitLogin').addEventListener("click", handleLogin, false);
    }
    if(document.getElementById('submitResetPaswword') !== null)
    {
        document.getElementById('submitResetPaswword').addEventListener("click", submitResetPassword, false);
    }
    if(document.getElementById('resetPassword') !== null)
    {
        document.getElementById('resetPassword').addEventListener("click", handleResetPassword, false);
    }
